module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qa"
  }, [_vm._l((_vm.qa), function(item, index) {
    return [_c('div', [_c('Item', {
      key: item.title,
      attrs: {
        "title": item.title,
        "content": item.content,
        "index": index,
        "isLast": index === _vm.qa.length - 1,
        "open": index === _vm.activeId
      },
      on: {
        "updateActiveId": _vm.updateActiveId
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-56658e37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionQuestion/Question.vue
// module id = 678
// module chunks = 0